import { useEffect } from "react";
import { useSessionStore } from "./stores/UserStore";
import { setCookie } from "./functions/utilFunctions";

const CookieHandler = () => {
  const session = useSessionStore((s) => s.session);
  useEffect(() => {
    setCookie("session", session);
  }, [session]);
  return "";
};

export default CookieHandler;
